import React from 'react';
import { FileLoadButton } from '../Controls/Button/FileLoadButton';
import { OnVideoFileLoadProps } from '../Models/SkitterbookOnVideoFileLoadProps';
import './css/SkitterBookVideoFileLoader.css';

interface SkitterBookVideoFileLoaderProps {
    skitterbookId: string | null;
    titleContent: React.ReactElement;
    tooltipText?: string;
    onVideoFileLoad?: (result: OnVideoFileLoadProps) => void;
}

export const SkitterBookVideoFileLoader: React.FC<SkitterBookVideoFileLoaderProps> = ({ skitterbookId, titleContent, tooltipText, onVideoFileLoad }) => {

    async function handleFile(file: File) {
        const buffer = await file.arrayBuffer();
        onVideoFileLoad?.({ videoBuffer: buffer, videoName: file.name });
    }

    return (
        <div className={`skitterbook-video-file-loader-container`}>
            {skitterbookId
                ? <></>
                : <div className="skitterbook-video-file-loader-inner-container">
                    <FileLoadButton
                        ariaLabel="skitterbookStart"
                        id="start-your-skitterbook"
                        className={`start-skitterbook-button component-button`}
                        toolTipText={tooltipText}
                        onLoaded={(file: File) => {
                            handleFile(file);
                        }}>

                        {titleContent}

                    </FileLoadButton>
                </div>
            }
        </div>
    );
};
